// @ts-nocheck
// import constants from "@store/constants";
// import loadResults from "@store/Framework/Store/Bunzl/Pages/BlogList/Handlers/LoadResults";
// import { lazyImageStyles } from "@store/Themes/common/mixins/lazyload";
// import { contentSpacingStyles } from "@store/Themes/common/mixins/spacing";
// import { getLoadingOverlayProps } from "@store/Themes/common/props/loadingOverlay";
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import { PageLinkModel } from "@insite/client-framework/Services/ContentService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getDataView, getDataViewKey } from "@insite/client-framework/Store/Data/DataState";
import { loadPagesForParent } from "@insite/client-framework/Store/Data/Pages/PagesActionCreators";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getPageLinkByNodeId } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import PageProps from "@insite/client-framework/Types/PageProps";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import Clickable, { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import LoadingOverlay, { LoadingOverlayProps } from "@insite/mobius/LoadingOverlay";
import Pagination, { PaginationPresentationProps } from "@insite/mobius/Pagination";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { get } from "@insite/mobius/utilities";
import convertToNumberIfString from "@insite/mobius/utilities/convertToNumberIfString";
import getColor from "@insite/mobius/utilities/getColor";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
// import GridContainer, { GridContainerProps } from "@store/MobiusOverrides/GridContainer/GridContainer"; // Store Custom Code
// import GridItem, { GridItemProps, GridWidths } from "@store/MobiusOverrides/GridItem/GridItem"; // Store Custom Code
// import LazyImage, { LazyImageProps } from "@store/MobiusOverrides/LazyImage/LazyImage"; // Store Custom Code
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import stripHtml from "@toolkit/Framework/Common/Utilities/stripHtml";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import parse from "html-react-parser";
import sortBy from "lodash/sortBy";
import * as React from "react";
import { FC, ReactElement, useEffect, useRef, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { CSSTransition } from "react-transition-group";
import { css, useTheme } from "styled-components";

/* Store Custom Code - Start */
import constants from "@store/constants";
import loadResults from "@store/Framework/Store/Bunzl/Pages/BlogList/Handlers/LoadResults";
import GridContainer, { GridContainerProps } from "@store/MobiusOverrides/GridContainer/GridContainer";
import GridItem, { GridItemProps, GridWidths } from "@store/MobiusOverrides/GridItem/GridItem";
import LazyImage, { LazyImageProps } from "@store/MobiusOverrides/LazyImage/LazyImage";
import { contentSpacingStyles, lazyImageStyles } from "@store/Themes/common/mixins";
import { getLoadingOverlayProps } from "@store/Themes/common/props/loadingOverlay";
/* Store Custom Code - End */
export const enum blogListLayoutTypes {
    grid = "grid",
    column = "column",
}

const enum fields {
    defaultPageSize = "defaultPageSize",
    itemsPerRow = "itemsPerRow",
    defaultCardImage = "defaultCardImage",
    noSearchResultsMessage = "noSearchResultsMessage",
    layoutType = "layoutType",
}

type BlogListViewFields = {
    [fields.defaultPageSize]: number;
    [fields.itemsPerRow]: number;
    [fields.defaultCardImage]: string;
    [fields.noSearchResultsMessage]: string;
    [fields.layoutType]: blogListLayoutTypes;
};

interface OwnProps extends WidgetProps {
    fields: BlogListViewFields;
    isSearchPage: boolean;
}

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => {
    const location = getLocation(state);
    const parsedQueryString = parseQueryString<{ page?: string; pageSize?: string; query?: string }>(location.search);
    const searchId = `blog-${getDataViewKey({ query: parsedQueryString.query })}`;
    const currentPage = getCurrentPage(state);
    const isSearchPage = currentPage.type === constants.pageType.blogList;
    const parameterId = isSearchPage ? searchId : currentPage.nodeId;
    const pagesDataView = getDataView(state.data.pages, {
        parentNodeId: parameterId,
    });
    const pages = {
        ...pagesDataView,
        value: pagesDataView.value?.filter(x => x.type === constants.pageType.blogPost),
    };
    let links: SafeDictionary<PageLinkModel> = {};
    if (pages.value) {
        links = pages.value.reduce(
            (links, page) => ({ ...links, [page.nodeId]: getPageLinkByNodeId(state, page.nodeId) }),
            {},
        );
    }
    return {
        parentNodeId: getCurrentPage(state).nodeId,
        pages,
        isSearchPage,
        links,
        location,
        parameter: {
            page: parsedQueryString.page ? convertToNumberIfString(parsedQueryString.page) : undefined,
            pageSize: parsedQueryString.pageSize ? convertToNumberIfString(parsedQueryString.pageSize) : undefined,
            id: parameterId,
            query: parsedQueryString.query,
        },
    };
};

const mapDispatchToProps = {
    loadPagesForParent,
    loadResults,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & HasHistory;

export interface BlogListViewStyles {
    loadingOverlay?: LoadingOverlayProps;
    listContainer?: GridContainerProps;
    blogListWrapper?: InjectableCss;
    searchResultsListTitle?: TypographyProps;
    blogHeaderPagesText?: InjectableCss;
    blogItem?: GridItemProps;
    blogItemWrapper?: InjectableCss;
    postImageWrapper?: InjectableCss;
    postImage?: LazyImageProps;
    postInformations?: InjectableCss;
    titleText?: TypographyProps;
    dateAndAuthorWrapper?: InjectableCss;
    authorImageWrapper?: InjectableCss;
    authorImage?: LazyImageProps;
    postImagePlaceholder?: InjectableCss;
    authorTextWrapper?: InjectableCss;
    authorText?: TypographyProps;
    publishDateText?: TypographyProps;
    textWrapper?: InjectableCss;
    summaryWrapper?: InjectableCss;
    readMoreLink?: LinkPresentationProps;
    paginationWrapper?: InjectableCss;
    pagination?: PaginationPresentationProps;
    noResultsTextWrapper?: InjectableCss;
    postImageLink?: ClickablePresentationProps;
}

const commonPostImageStyles = `position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    `;

export const blogListViewStyles: BlogListViewStyles = {
    loadingOverlay: getLoadingOverlayProps(),
    listContainer: {
        gap: 20,
    },
    searchResultsListTitle: {
        as: "h2",
        variant: "h2",
        css: css`
            text-align: center;
        `,
    },
    blogHeaderPagesText: {
        css: css`
            ${spacingStyles()}
            text-align: right;
        `,
    },
    blogItemWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            height: 100%;
            width: 100%;
            max-width: 100%;
            padding: 0;
            ${contentSpacingStyles(pxToRem(30), 0, pxToRem(30))}
        `,
    },
    postImageWrapper: {},
    postImage: {
        css: css`
            position: relative;
            width: 100%;
            padding-top: 100%;
            ${lazyImageStyles()}

            img {
                position: absolute;
                top: 0;
                width: auto;
                max-height: 100%;
                max-width: none;
            }
        `,
    },
    postInformations: {
        css: css`
            display: flex;
            align-items: center;
            max-width: ${pxToRem(500)};
        `,
    },
    postImagePlaceholder: {
        css: css`
            ${commonPostImageStyles}
            background: linear-gradient(210deg, ${getColor("common.accent")}, ${getColor("common.borderDark")});
        `,
    },
    titleText: {
        variant: "headerTertiary",
        as: "h2",
    },
    dateAndAuthorWrapper: {
        css: css`
            display: flex;
            width: 100%;
        `,
    },
    authorImageWrapper: {
        css: css`
            margin-right: ${pxToRem(15)};
        `,
    },
    authorImage: {
        css: css`
            max-width: ${pxToRem(50)};
            max-height: ${pxToRem(50)};
            width: auto;
            height: auto;
            align-items: center;
        `,
    },
    authorTextWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            justify-content: center;
        `,
    },
    authorText: {
        css: css`
            font-size: ${x => x.theme.design.typography.size.small};
            margin-right: ${pxToRem(15)};
        `,
    },
    publishDateText: {
        css: css`
            font-style: italic;
            font-size: ${x => x.theme.design.typography.size.smaller};
        `,
    },
    textWrapper: {
        css: css`
            padding: ${pxToRem(15, 0)};

            ${breakpoint("sm")} {
                padding: ${pxToRem(15)};
            }
        `,
    },
    summaryWrapper: {
        css: css`
            ${spacingStyles(pxToRem(16), pxToRem(16))}
            font-size: ${x => x.theme.design.typography.size.small};
        `,
    },
    readMoreLink: {
        typographyProps: {
            css: css`
                text-align: right;
                font-size: ${x => x.theme.design.typography.size.small};
            `,
        },
    },
    paginationWrapper: {
        css: css`
            display: flex;
            justify-content: center;
            margin-top: ${pxToRem(30)};
            width: 100%;
        `,
    },
    pagination: {
        cssOverrides: {
            pagination: css`
                padding-top: ${pxToRem(15)};
            `,
        },
    },
    noResultsTextWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            gap: ${pxToRem(15)};
            text-align: center;
        `,
    },
    postImageLink: {
        css: css`
            width: 100%;
        `,
    },
};

const styles = blogListViewStyles;

function useIsInViewport(ref: React.RefObject<HTMLDivElement>) {
    const [isIntersecting, setIsIntersecting] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => setIsIntersecting(entry.isIntersecting));

        if (ref.current) {
            observer.observe(ref.current as Element);
        }

        return () => {
            observer.disconnect();
        };
    }, [ref]);

    return isIntersecting;
}

const BlogListView: FC<Props> = ({
    links,
    pages,
    fields,
    isSearchPage,
    location,
    parameter,
    history,
    loadResults,
    loadPagesForParent,
}) => {
    const { defaultPageSize, itemsPerRow, defaultCardImage, noSearchResultsMessage } = fields;

    if (!pages.value && !pages.isLoading) {
        if (isSearchPage) {
            loadResults({
                id: parameter.id,
                query: parameter.query,
                page: parameter.page,
                pageSize: parameter.pageSize,
            });
        } else {
            loadPagesForParent({
                page: parameter.page,
                pageSize: parameter.pageSize,
                parentNodeId: parameter.id,
            });
        }
    }

    const changePage = (newPageIndex: number) => {
        updateQueryString(newPageIndex, parameter.pageSize);
    };

    const changeResultsPerPage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const newPageSize = parseInt(event.currentTarget.value, 10);
        updateQueryString(1, newPageSize);
    };

    const updateQueryString = (page: number, pageSize?: number) => {
        let newLocation = `${location.pathname}?${
            isSearchPage && parameter.query ? `query=${parameter.query}&` : ""
        }page=${page}`;
        if (pageSize) {
            newLocation += `&pageSize=${pageSize}`;
        }
        history.push(newLocation);
    };

    const totalItems = pages.value?.length || 0;
    const page = parameter.page ?? 1;
    const pageSize = parameter.pageSize ?? defaultPageSize;
    const totalPages = Math.ceil(totalItems / pageSize);

    const sortedAndPagedPages = sortBy(pages.value, o => o.fields["publishDate"])
        .reverse()
        .slice((page - 1) * pageSize, page * pageSize);

    return (
        <StyledWrapper {...styles.blogListWrapper}>
            {isSearchPage && (
                <Typography {...styles.searchResultsListTitle}>
                    {parameter.query
                        ? `${translate("Search Results for")} "${parameter.query}"`
                        : translate("Search Results")}
                </Typography>
            )}
            <LoadingOverlay loading={!pages.value || pages.isLoading} {...styles.loadingOverlay}>
                {totalItems > 0 && !pages.isLoading ? (
                    sortedAndPagedPages.length ? (
                        <>
                            {totalItems > pageSize && (
                                <StyledWrapper {...styles.blogHeaderPagesText}>
                                    <Typography>
                                        {translate("Page {0} of {1}")
                                            .replace("{0}", page.toString())
                                            .replace("{1}", totalPages.toString())}{" "}
                                        &mdash; {translate("Total of {0} posts").replace("{0}", totalItems.toString())}
                                    </Typography>
                                </StyledWrapper>
                            )}
                            <BlogListContainer
                                itemsPerRow={itemsPerRow}
                                sortedAndPagedPages={sortedAndPagedPages}
                                layoutType={fields.layoutType}
                            >
                                {(page, index) => (
                                    <BlogListElement
                                        page={page}
                                        fields={fields}
                                        links={links}
                                        defaultCardImage={defaultCardImage}
                                        index={index}
                                    />
                                )}
                            </BlogListContainer>
                            {totalItems > pageSize && (
                                <StyledWrapper {...styles.paginationWrapper}>
                                    <Pagination
                                        resultsCount={totalItems}
                                        currentPage={page}
                                        resultsPerPage={pageSize}
                                        resultsPerPageOptions={[pageSize, pageSize * 2, pageSize * 3, pageSize * 4]}
                                        onChangePage={changePage}
                                        onChangeResultsPerPage={changeResultsPerPage}
                                        pageSizeCookie="BlogList-PageSize"
                                        {...styles.pagination}
                                    />
                                </StyledWrapper>
                            )}
                        </>
                    ) : null
                ) : null}
                {totalItems === 0 && !pages.isLoading ? (
                    <StyledWrapper {...styles.noResultsTextWrapper}>
                        <Typography>
                            {translate('No results for "{0}".').replace(
                                "{0}",
                                parameter.query || translate("this search query"),
                            )}
                        </Typography>
                        {noSearchResultsMessage && (
                            <Typography>{parse(noSearchResultsMessage, parserOptions)}</Typography>
                        )}
                    </StyledWrapper>
                ) : null}
            </LoadingOverlay>
        </StyledWrapper>
    );
};

type BlogListElementProps = {
    page: PageProps;
    fields: BlogListViewFields;
    links: SafeDictionary<PageLinkModel>;
    defaultCardImage: string;
    index: number;
};

const BlogListElement: FC<BlogListElementProps> = ({ page, fields, links, defaultCardImage, index }) => {
    const ref = useRef<HTMLDivElement>(null);
    const isInViewport = useIsInViewport(ref);
    const theme = useTheme();
    const transitionLength = get(theme, `transition.duration.long`);

    const blogItemWrapperStyles: InjectableCss = {
        ...styles.blogItemWrapper,
        css: css`
            ${styles.blogItemWrapper?.css}
            display: flex;

            ${fields.layoutType === blogListLayoutTypes.column
                ? css`
                      ${breakpoint("sm")} {
                          .blogItemTransition {
                              flex-direction: row;
                          }

                          &:nth-child(odd) > .blogItemTransition {
                              text-align: right;
                              flex-direction: row-reverse;

                              .postInformations,
                              .dateAndAuthorWrapper {
                                  justify-content: flex-end;
                              }
                          }
                      }
                  `
                : css`
                      flex-direction: column;
                  `}
        `,
    };

    const blogItemTransitionStyles: InjectableCss = {
        css: css`
            display: flex;
            width: 100%;

            ${fields.layoutType === blogListLayoutTypes.column
                ? css`
                      justify-content: space-around;

                      ${breakpoint("xs", "down")} {
                          flex-direction: column;
                      }

                      &.blogListItem-enter {
                          transform: translateY(${pxToRem(25)});
                          opacity: 0;
                      }

                      &.blogListItem-enter-active {
                          opacity: 1;
                          transform: translateY(0);
                          transition: all ease-in-out ${transitionLength}ms;
                      }

                      &.blogListItem-exit {
                          transform: translateY(0);
                          opacity: 1;
                      }

                      &.blogListItem-exit-active {
                          transform: translateY(${pxToRem(-25)});
                          opacity: 0;
                          transition: all ease-in-out ${transitionLength}ms;
                      }
                  `
                : css`
                      flex-direction: column;
                  `}
        `,
    };

    const postImageWrapperStyles: InjectableCss = {
        ...styles.postImageWrapper,
        css: css`
            ${styles.postImageWrapper?.css}

            ${fields.layoutType === blogListLayoutTypes.column &&
            css`
                width: 100%;

                ${breakpoint("sm")} {
                    width: 40%;
                }
            `}
        `,
    };

    const postInformationsStyles: InjectableCss = {
        ...styles.postInformations,
        css: css`
            ${styles.postInformations?.css}

            ${fields.layoutType === blogListLayoutTypes.column &&
            css`
                width: 100%;

                ${breakpoint("sm")} {
                    width: 50%;
                }
            `}
        `,
    };

    return (
        <StyledWrapper ref={ref} {...blogItemWrapperStyles}>
            <CSSTransition
                mountOnEnter
                unmountOnExit
                in={isInViewport}
                timeout={{
                    enter: transitionLength,
                    exit: transitionLength,
                }}
                classNames="blogListItem"
            >
                <StyledWrapper className="blogItemTransition" {...blogItemTransitionStyles}>
                    <StyledWrapper {...postImageWrapperStyles}>
                        <Clickable href={links[page.nodeId]?.url} {...styles.postImageLink}>
                            <LazyImage
                                src={page.fields["openGraphImage"] || defaultCardImage}
                                altText={page.fields["title"]}
                                {...styles.postImage}
                            />
                        </Clickable>
                    </StyledWrapper>
                    <StyledWrapper className="postInformations" {...postInformationsStyles}>
                        <StyledWrapper {...styles.textWrapper}>
                            <Typography {...styles.titleText}>
                                <Link href={links[page.nodeId]?.url}>{page.fields["title"]}</Link>
                            </Typography>
                            <StyledWrapper className="dateAndAuthorWrapper" {...styles.dateAndAuthorWrapper}>
                                {page.fields["authorImage"] && (
                                    <StyledWrapper {...styles.authorImageWrapper}>
                                        <LazyImage src={page.fields["authorImage"]} {...styles.authorImage} />
                                    </StyledWrapper>
                                )}
                                <StyledWrapper {...styles.authorTextWrapper}>
                                    {page.fields["authorName"] && (
                                        <Typography {...styles.authorText}>{page.fields["authorName"]}</Typography>
                                    )}
                                    {page.fields["publishDate"] && (
                                        <Typography {...styles.publishDateText}>
                                            <LocalizedDateTime
                                                dateTime={new Date(page.fields["publishDate"])}
                                                options={{
                                                    year: "numeric",
                                                    month: "long",
                                                    day: "numeric",
                                                }}
                                            />
                                        </Typography>
                                    )}
                                </StyledWrapper>
                            </StyledWrapper>
                            {page.fields["blogShortDescription"] && (
                                <StyledWrapper {...styles.summaryWrapper}>
                                    {parse(stripHtml(page.fields["blogShortDescription"] || ""), parserOptions)}
                                </StyledWrapper>
                            )}
                            <Link href={links[page.nodeId]?.url} {...styles.readMoreLink}>
                                {translate("Read More")}
                            </Link>
                        </StyledWrapper>
                    </StyledWrapper>
                </StyledWrapper>
            </CSSTransition>
        </StyledWrapper>
    );
};

type BlogListContainerProps = {
    itemsPerRow?: number;
    sortedAndPagedPages: PageProps[];
    layoutType: blogListLayoutTypes;
    children?: (page: PageProps, index: number) => ReactElement;
};

const BlogListContainer: FC<BlogListContainerProps> = ({ children, itemsPerRow, sortedAndPagedPages, layoutType }) => {
    const layout = () => {
        switch (layoutType) {
            case blogListLayoutTypes.column:
                return <>{sortedAndPagedPages.map((page: PageProps, index) => children?.(page, index))}</>;

            case blogListLayoutTypes.grid:
                return (
                    <GridContainer {...styles.listContainer}>
                        {sortedAndPagedPages.map((page: PageProps, index) => (
                            <GridItem
                                width={[12, 6, itemsPerRow, itemsPerRow, itemsPerRow] as GridWidths[]}
                                key={page.id}
                            >
                                {children?.(page, index)}
                            </GridItem>
                        ))}
                    </GridContainer>
                );
        }
    };

    return layout();
};

const widgetModule: WidgetModule = {
    component: withHistory(connect(mapStateToProps, mapDispatchToProps)(BlogListView)),
    definition: {
        group: constants.widgetGroup.blogList as any,
        allowedContexts: [constants.pageType.blogHome, constants.pageType.blogList] as any,
        fieldDefinitions: [
            {
                name: fields.defaultPageSize,
                editorTemplate: "IntegerField",
                defaultValue: 5,
                fieldType: "General",
                min: 1,
                max: 20,
                sortOrder: 101,
            },
            {
                name: fields.layoutType,
                editorTemplate: "DropDownField",
                defaultValue: blogListLayoutTypes.column,
                fieldType: "General",
                options: [
                    {
                        displayName: "Grid",
                        value: blogListLayoutTypes.grid,
                    },
                    {
                        displayName: "Column",
                        value: blogListLayoutTypes.column,
                    },
                ],
                sortOrder: 102,
            },
            {
                name: fields.itemsPerRow,
                editorTemplate: "DropDownField",
                defaultValue: 4,
                fieldType: "General",
                options: [
                    {
                        displayName: "2",
                        value: 6,
                    },
                    {
                        displayName: "3",
                        value: 4,
                    },
                    {
                        displayName: "4",
                        value: 3,
                    },
                ],
                sortOrder: 102,
                isVisible: item => item.fields.layoutType === "grid",
            },
            {
                name: "defaultCardImage",
                defaultValue: "",
                editorTemplate: "ImagePickerField",
                tooltip: "Suggested size: 1200x630, like OpenGraph Image",
                fieldType: "General",
                sortOrder: 103,
            },
            {
                name: "noSearchResultsMessage",
                editorTemplate: "RichTextField",
                tooltip:
                    "When used in context of a Search Results page, this text will be shown when no results are found.",
                fieldType: "Translatable",
                defaultValue: "Make a new search or go back to the Blog home page.",
                sortOrder: 104,
            },
        ],
    },
};

export default widgetModule;
